var _effectorFileName = "/src/page-content/legal-notice/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const legalNoticePage = declarePage({
  pageType: pagesPath.$url().pathname
});